import React, { Component } from 'react';
import Link from 'gatsby-link';
import styled from 'styled-components';
import {
  PublicationExternalLink,
  ButtonModal,
  PdfViewer,
  PublicationYear,
  SplitSectionPublication,
  LeftSectionPublication,
  RightSectionPublication,
  PublicationImage,
  TeamList,
  TeamListItem,
  TeamListItemGrey,
  PublicationLink,
  Title,
  SubTitle
} from '../../static/styles/styles';
import Navigation from '../../componenten/Navigation';
import Modal from '../../componenten/Modal';

import '../../static/styles/modal.css';

const Sticky = styled.div`
  position: sticky;
  background-color: #fff;
  top: 160px;
  z-index: 3;
`;

class PublicatiePage extends Component {
  state = {
    isOpen: false,
    document: null,
    title: null
  };
  render() {
    const navItems = this.props.data.allNavigationJson.edges;
    const publicationItems = this.props.data.allPublicatiesJson.edges[0].node;
    const subNavItems = navItems.filter(
      ({ node: navItem }, index) => index === 2
    );
    return (
      <div>
        <Sticky>
          <Navigation items={subNavItems} navType="sub" />
        </Sticky>
        {publicationItems.publicaties.map((publicationByYear, index) => {
          return (
            <div key={index}>
              <PublicationYear>{publicationByYear.year}</PublicationYear>
              {publicationByYear.publications.map((publication, index) => {
                return (
                  <SplitSectionPublication key={index}>
                    <LeftSectionPublication>
                      <PublicationImage src={publication.img} alt="" />
                    </LeftSectionPublication>
                    <RightSectionPublication>
                      <Title>{publication.titel}</Title>
                      <SubTitle>{publication.subtitel}</SubTitle>
                      {publication.document !== '' ? (
                        <PublicationLink
                          onClick={() =>
                            this.setState({
                              isOpen: true,
                              document: publication.document,
                              title: publication.title
                            })
                          }
                        >
                          Bekijk volledige publicatie
                        </PublicationLink>
                      ) : null}
                      {publication.url !== '' ? (
                        <PublicationExternalLink
                          href={publication.url}
                          target="_blank"
                        >
                          Bekijk online publicatie
                        </PublicationExternalLink>
                      ) : null}
                    </RightSectionPublication>
                  </SplitSectionPublication>
                );
              })}
            </div>
          );
        })}
        <Modal isOpen={this.state.isOpen}>
          <PdfViewer data={this.state.document} type="application/pdf">
            <embed src={this.state.document} type="application/pdf" />
          </PdfViewer>
          <ButtonModal onClick={() => this.setState({ isOpen: false })}>
            X SLUIT
          </ButtonModal>
        </Modal>
      </div>
    );
  }
}

export const pageQuery = graphql`
  query PublicatiePageQuery {
    allNavigationJson {
      edges {
        node {
          to
          name
          key
          sub
          subItems {
            to
            name
            key
          }
        }
      }
    }
    allPublicatiesJson {
      edges {
        node {
          publicaties {
            year
            publications {
              img
              titel
              subtitel
              document
              url
            }
          }
        }
      }
    }
  }
`;

export default PublicatiePage;



// WEBPACK FOOTER //
// ./src/pages/nieuws/publicatie.js